/**
 * File Name          : device-settings.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Component, Input } from '@angular/core';
import { DatasnapDevice } from '../../models/datasnap-device.model';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { ScreenserviceService } from '../../services/screenservice.service';
import { SensorBatteryComponent } from '../icons/sensor-battery/sensor-battery.component';
import { DatasnapDeviceService } from '../../services/datasnap-device.service';
import { confirm, alert } from 'devextreme/ui/dialog';
import { ConsoleCaptureService } from '../../services/console-capture.service';


@Component({
  selector: 'app-device-settings',
  standalone: true,
  imports: [CommonModule, DxButtonModule, SensorBatteryComponent],
  templateUrl: './device-settings.component.html',
  styleUrl: './device-settings.component.scss'
})
export class DeviceSettingsComponent {

  @Input() device?: DatasnapDevice;

  constructor(public screenService: ScreenserviceService, private datasnapDeviceService: DatasnapDeviceService, private consoleCaptureService: ConsoleCaptureService) {
    
  }

  downloadRawData = () => {
    if(this.device?.parsedData !== null) {
      this.device?.downloadRawData();
    }
    this.consoleCaptureService.downloadLogs();
  }

  resetDevice = () => {
    confirm("This will restart your DataSnap. Any recording in progress or not yet downloaded may be lost. Continue?", "Reset DataSnap").then((confirmed) => {
      if(!confirmed || !this.device) return;
      this.datasnapDeviceService.rebootDevice(this.device).then(() => {
        alert("Your DataSnap is restarting. Wait a few seconds, then reconnect it.", "Reset DataSnap");
      }).catch((err) => {
        console.error("Failed to reset DataSnap:", err);
        alert("Could not reset the DataSnap. Please try again.", "Reset DataSnap");
      });
    });
  }

  removeDevice = () => {
    
    confirm("Are you sure you want to disconnect your device? All progress will be lost", "Disconnect Device").then((dialogResult) => {
      if (dialogResult) {
        if(!this.device) return;
        this.datasnapDeviceService.removeDevice(this.device);
      }
    }).catch((error) => {
      console.error("Error showing confirmation dialog:", error);
    });
    
  }
}
